<template>
  <el-dialog
    :visible.sync="dialog"
    width="950px"
    center
    :before-close="handleClose"
    custom-class="my-dialog"
  >
    <div
      class="ReactModal__Content ReactModal__Content--after-open pano-modal-main WarningModal_modal_u48Qn4"
      tabindex="-1"
      role="dialog"
      aria-label="modal"
    >
      <div class="pano-modal-header">操作确认</div>
      <div class="pano-modal-body">
        <div v-for="(value, i) in infos" :key="i">
          <div class="gourpName">
            <div>
              {{ value.groupName == null ? "默认一级分组" : value.groupName }}
            </div>
          </div>
          <div class="groupList">
            <div
              :class="{
                'choose-li': true,
                active: arr.length > 0 && arr[i].panos[j].chooseActive,
              }"
              v-for="(item, j) in value.panos"
              :id="item.physicalFile.id"
              :key="item.id"
              @click="chooseOne(i, j)"
            >
              <img :src="item.physicalFile.thumbnailUrl" />
              <div class="name">{{ item.physicalFile.fileName }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="pano-modal-footer">
        <div class="ScenesSelectModal_footer_kL9Mp1">
          <!-- <div class="ScenesSelectModal_all_3B8BLR">
            <div class="Checkbox_container_jYKPxJ">
              <el-checkbox v-model="allcheck">全选</el-checkbox>
            </div>
          </div> -->
          <a
            @click="confirm"
            :class="{
              'pano-button': true,
              'pano-button-md': true,
              'pano-button-important': true,
              'ScenesSelectModal_confirmBtn_2Qd-c6': true,
              'pano-button-disabled': isdiable,
            }"
            :disabled="isdiable"
            >确 定</a
          >
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<style>
.el-checkbox span {
  color: #333;
}
</style>
<style scoped>
.pano-button-disabled,
.pano-button-disabled:hover {
  background-color: #d8d8d8 !important;
  color: #fff !important;
  border: 1px solid #d8d8d8;
  cursor: not-allowed !important;
}
.ScenesSelectModal_footer_kL9Mp1 {
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.ScenesSelectModal_all_3B8BLR {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 30px;
}
.ScenesSelectModal_confirmBtn_2Qd-c6 {
  width: 120px;
}
/* .active {
  outline: rgb(255, 189, 16) solid 2px;
  outline-offset: -2px;
} */
.ScenesSelectModal_body_1db5-e {
  padding: 20px 30px;
}
.ScenesSelectModal_group_1y_Y4c {
  margin-bottom: 20px;
}
.ScenesSelectModal_groupTitle_3XeQZE {
  padding-left: 5px;
  height: 15px;
}

.MaxWidthText_ellipsis_3dq6uh {
  display: inlint-block;
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  overflow: hidden;
}
.ScenesSelectModal_list_3JykoI {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-flow: row wrap;
  flex-flow: row wrap;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.ScenesSelectModal_item_1HUY34 {
  width: 84px;
  margin: 10px 5px 0;
  cursor: pointer;
}
.ScenesSelectModal_thumb_3fMuQe {
  height: 84px;
  margin-bottom: 8px;
}
.ScenesSelectModal_name_2mjeGp {
  text-align: center;
  font-size: 12px;
  line-height: 16px;
}
.my-dialog {
  z-index: 10000;
  color: black;
}
.my-dialog.el-dialog--center .el-dialog__body {
  padding: 0 0 10px 0;
}

/* .my-dialog .el-dialog__header {
  padding: 0;
} */

.my-dialog .el-dialog__headerbtn {
  top: 7px;
  right: 7px;
  z-index: 10;
}
</style>
<style scoped>
.pano-modal-footer {
  border-top: 1px solid #e9e9e9;
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 65px;
}
.WarningModal_btns_ye5uuP {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 260px;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
.WarningModal_btn_nkUu3j {
  width: 120px;
}
.pano-button-md {
  height: 34px;
}
.pano-button-important {
  background-color: #db4437;
  color: #fff;
}
.pano-button {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 30px;
  padding-left: 15px;
  padding-right: 15px;
  border-radius: 3px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
}
.pano-button-gray {
  background-color: rgba(0, 0, 0, 0);
  color: #4a4a4a;
  border: 1px solid #c4c4c4;
}
.el-dialog__header {
  padding: 0;
}
.WarningModal_modal_u48Qn4 {
  width: 950px;
  height: 620px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.pano-modal-header {
  /* width: 100%; */
  position: relative;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 60px;
  padding: 0 20px;
  border-radius: 6px 6px 0 0;
  font-size: 20px;
  border-bottom: 1px solid #e9e9e9;
  display: flex;
  color: black;
}
.pano-modal-body {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex: 1 auto;
  flex: 1 auto;
  padding: 0 20px;
}
.WarningModal_warning_qTPb3x {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-flow: column nowrap;
  flex-flow: column nowrap;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  line-height: 1.4;
  text-align: center;
}
.WarningModal_img_2bWrGD {
  width: 80px;
  height: 80px;
  margin-bottom: 10px;
}
.WarningModal_warningTitle_24i5_o {
  font-size: 18px;
  color: #5c5c5c;
}
.WarningModal_tip_2EsHEF {
  width: 400px;
  color: #7a7a7a;
}
.pano-modal-body {
  position: relative;
  -webkit-box-flex: 1;
  -ms-flex: 1 auto;
  flex: 1 auto;
}
.pano-header {
  height: 60px;
  display: flex;
  align-items: center;
  position: relative;
  padding: 0 20px;
  font-size: 20px;
  border-bottom: 1px solid #e9e9e9;
}

.title {
  margin-right: 20px;
  font-size: 16px;
  font-weight: 700;
  color: black;
}

.select {
  flex: 1 auto;
}

.input-with-select {
  width: 200px;
}

.upload-block {
  font-size: 14px;
}

.pano-model-body {
  position: relative;
  flex: 1 auto;
}

.title-line {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  background-color: #f3f3f3;
  border-bottom: 1px solid #e9e9e9;
}

.title-line-left {
  display: flex;
  align-items: center;
}
.all-word {
  color: black;
}

.checkbox-block {
  margin-right: 10px;
}

.checkbox {
  height: 16px;
  width: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  border: 1px solid #d8d8d8;
  cursor: pointer;
  color: white !important;
}

.checkbox.active {
  background-color: #427afb;
  border-color: #427afb;
}

.list {
  height: 435px;
}

.list-li {
  height: 50px;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0 40px;
  border-bottom: 1px solid #e9e9e9;
}

.middle {
  display: flex;
  flex: 1 auto;
  align-items: center;
}

.img-block {
  width: 30px;
  height: 30px;
  background-color: #ddd;
  cursor: pointer;
}

.img-block img {
  width: 100%;
  height: 100%;
}

.li-title {
  max-width: 500px;

  margin-left: 10px;
  line-height: 30px;
  font-size: 12px;
  white-space: nowrap;
  -o-text-overflow: ellipsis;
  text-overflow: ellipsis;
  overflow: hidden;
  cursor: pointer;
  color: black;
}

.date {
  font-size: 12px;
  color: #9b9b9b;
}

.page-block {
  display: flex;
  justify-content: center;
}

.choose-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 10px;
}

.choose-li {
  display: inline-block;
  width: 83px;
  margin-left: 15px;
  margin-bottom: 15px;
  cursor: pointer;
}
.choose-li.active img {
  height: 83px;
  background-color: rgb(221, 221, 221);
  outline: rgb(255, 189, 16) solid 2px;
  outline-offset: -2px;
}

.choose-li img {
  height: auto;
  width: 100%;
}

.choose-li .name {
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow-wrap: normal;
  width: 100%;
  margin-top: 8px;
  line-height: 16px;
  font-size: 12px;
  text-align: center;
}

.gourpName {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0px 15px;
  height: 44px;
  margin-bottom: 15px;
  background: rgb(247, 247, 247);
}
.gourpName > div {
  margin-left: 10px;

  color: #333;
}
.groupList * {
  color: #333;
}
</style>
<script>
import https from "../https.js";
import Upload from "../components/upload.vue";
export default {
  name: "",
  props: {
    infos: Array,
    closeAlert: Function,
  },
  components: {
    Upload: Upload,
  },

  data() {
    return {
      dialog: true,
      isdiable: true,
      arr: [],
    };
  },
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    confirm() {
      let ids=[];
      for (var i = 0; i < this.arr.length; i++) {
        for (var j = 0; j < this.arr[i].panos.length; j++) {
          if (this.arr[i].panos[j].chooseActive) {
            ids.push(this.arr[i].panos[j].id)
          }
        }
      }
      console.log(ids)
      this.$parent.renewInfos(ids)
      this.closeAlert();
    },
    closealert() {
      this.closeAlert();
    },
    init() {
      for (var i = 0; i < this.infos.length; i++) {
        let json = {
          panos: [],
        };
        for (var j = 0; j < this.infos[i].panos.length; j++) {
          let json2 = {
            id: this.infos[i].panos[j].physicalFile.id,
            chooseActive: false,
          };
          json.panos.push(json2);
        }
        this.arr.push(json);
      }
    },
    chooseOne(i, j, str) {
      this.arr[i].panos[j].chooseActive = !this.arr[i].panos[j].chooseActive;

      this.isdiable = true;
      for (var i = 0; i < this.arr.length; i++) {
        for (var j = 0; j < this.arr[i].panos.length; j++) {
          if (this.arr[i].panos[j].chooseActive) {
            this.isdiable = false;
            break;
          }
        }
      }
    },
    handleClose(done) {
      this.closeAlert();
    },
    submit() {
      this.submitFunc(this.chooseArr);
      this.closeFunc();
    },
  },
};
</script>
